import { Injectable } from '@angular/core';
import { CredentialsModel } from "../../nmodels/auth/credentials.model";
import { AnonymousModel } from "../../nmodels/auth/anonymous.model";
import { Router } from '@angular/router';

@Injectable()
export class CredentialsService {
  private anonymous:AnonymousModel;
  private credentials?:CredentialsModel;
  constructor(private _router:Router) { 

  }

  /**
   * retorna true o false si existen credenciales validas
   */
  getCredentials(){
    if(localStorage.getItem("credentials")){
      this.credentials = JSON.parse(localStorage.getItem('credentials'));
      if(this.verifyValidToken())
        return true;
      return false;
    }
    return false;
  }
  /*
  set credentials as authenticated user in local storage and local variable
  */
  setCredentials(credentials:CredentialsModel){
    this.credentials = credentials;
    this.credentials.token_date = new Date().valueOf();
    localStorage.setItem("credentials",JSON.stringify(this.credentials));
    // console.log("credentials Service: crdentials saved");
    // console.log(this.credentials);
    
    
  }
  /*
  set credentials as anonymous user in local variable
  */
  setCredentialsAnonynous(anonymous:AnonymousModel){
    this.anonymous = anonymous;
  }
  /*
  return true if there's and anonymous user
   */
  getCredentialsAnonymous(){
    if(this.anonymous)
      return this.anonymous;
    else return null;
  }
  /**
   * delete credentials from authenticated or anonynous user
   */
  makeLogout(){
    this.credentials = null;
    this.anonymous = null;
    localStorage.removeItem("credentials");
  }
  /**
   * return object user if exist or null if not
   */
  getCredentialsUser(){
    if(this.credentials.user)
      return this.credentials.user
    else return null;
  }
  /**
   * return token string  if exist or null if not
   */
  getCredentialsToken(){
    if(this.credentials.auth_token)
      return this.credentials.auth_token;
    else return null;
  }
  /**
   * return expires time as number if exist or null if not
   */
  getCredentialsExpires(){
    if (this.credentials.expires_in) {
      let time = String(this.credentials.expires_in);
      time = time+"000";
      return Number(time);
    }
  }
  /**
   * return token_type string if exist or null if not
   */
  getCredentialsTokenType():string{
    if (this.credentials.token_type) 
      return this.credentials.token_type;
    else return null;
  }
  getCredentialsTokenDate():number{
    if(this.credentials.token_date)
      return this.credentials.token_date;
    else return null;
  }

  getCredentialsTokenValues():any{
    if(this.credentials.token_type && this.credentials.expires_in && this.credentials.auth_token){
      return {
        token_type: this.credentials.token_type,
        expires_in: this.getCredentialsExpires(),
        auth_token: this.credentials.auth_token,
      }
    }
    else return null;
  }
/**
 * valida si el token de el usuario en sesion es valido, retorna verdadero o falso segun sea el caso
 */
  verifyValidToken(){
    let localTime = new Date().valueOf();
    let tendaysBefore = this.getCredentialsTokenDate()+this.getCredentialsExpires();
    if(tendaysBefore>localTime)
      return true;//valid token
    else return false; //invalid token
  }
/**
 * recibe un numero de usuario, valida si este es igual al id de el usuario en sesion
 * @param user_id 
 */
  validSameUserId(user_id:number){
    if(user_id == this.credentials.user.id)
    return true;
    else return false;
  }
  /**
   * reutnr a user_id if there are valid credentials else return null
   */
  getCredentialsUserId():number{
    if(this.getCredentials())
      return this.credentials.user.id;
    else return null;
  }

}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/nservices/login/credentials.service.ts